import React from 'react';

import { SCORE_OPTIONS } from
  '../../../../Context/DynamicFormContext';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputStars from '../../../FormFields/Stars';
import InputNumber from '../../../FormFields/Number';
import InputSelect from '../../../FormFields/Select';
import Checkbox from '../../../FormFields/Checkbox';
import withConditionsAndTriggers from '../withConditionsAndTriggers';

export class StarsWidget extends React.PureComponent {
  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label') }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputText label='Description' value={ api.getFieldsVerbiage(internalField, 'description') }
                   onChange={ (v) => changeFieldValue('description', v) }/>
        <InputNumber label='Number of stars' value={ internalField.numberStars }
                   onChange={ (v) => changeFieldValue('numberStars', v) }/>
        <InputSelect label='Score type' options={ SCORE_OPTIONS } value={ internalField.scoreType }
                     onChange={ (v) => changeFieldValue('scoreType', v) }/>
        
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className='InputCheckboxesWrapper'>
          <Checkbox onChange={ (v) => changeFieldValue('labelInline', v) } label='Label inline'
                    checked={ internalField.labelInline }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('required', v) } label='Required'
                    checked={ internalField.required }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('photo', v) } label='Photo'
                    checked={ internalField.photo }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('notes', v) } label='Notes'
                    checked={ internalField.notes }
                    className='InputCheckbox_Block'/>
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, error, onChange, onError } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Stars Rating',
    };
    return (
      <WrapperWidget {...props}>
        <div className='StarsWidget'>
          <InputStars
            disabled={ field.disabled }
            required={ field.required }
            stars={ field.numberStars }
            value={ value }
            onChange={ onChange }
            onError={ onError }
            error={error}
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const StarsWidgetEditable = withConditionsAndTriggers(StarsWidget);